import URL from '@/tools/url';
import jquery from 'jquery';
import _toInteger from 'lodash/toInteger';

/**
 * @memberof module:ajaxAPI/product
 * @alias get

 * @description
 * Получение информации о товаре
 *
 * @param {number} id - id товара
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.product.get(123456)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = {
    lang: _lang,
    format: 'json',
    accessories: true
  };
  var result = jquery.Deferred();

  if (Products._products[id]) {
    var product = Products._products[id].product;
    result.resolve(product);

    return result.promise();
  }

  jquery.getJSON('/product_by_id/' + _toInteger(id) + '.json', fields)
    .done(function(response) {
      if (response.product && _lang) {
        response.product.url += '?lang=' + _lang;
      }

      result.resolve(response.product);
    })
    .fail(function(response) {
      console.log('JSON: ошибка при получении данных от платформы', response);
      result.resolve({});
    });

  return result.promise();
}
